define.alias("shared/components/shared/post/profile-selector", "media/components/shared/post/profile-selector/index");